/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type IncidentTelegramTargetAddressTypeEnum =
  (typeof IncidentTelegramTargetAddressTypeEnum)[keyof typeof IncidentTelegramTargetAddressTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IncidentTelegramTargetAddressTypeEnum = {
  HOME: 'HOME',
  PUBLIC_PLACE: 'PUBLIC_PLACE',
  WORKPLACE: 'WORKPLACE',
  STREET: 'STREET',
  ABOVE_GROUND: 'ABOVE_GROUND',
  UNDERGROUND: 'UNDERGROUND',
  OTHER: 'OTHER',
} as const;
